import * as React from 'react';
import { apiFetch } from '../lib/apiClient';

/**
 * Fetches the workspace brand primary color from the API.
 * Returns a 6-char hex string (no #), or null while loading.
 * Defaults to '1E3A5F' on error.
 */
export function useBrandPrimaryColor(): string | null {
  const [color, setColor] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    apiFetch<{ colors: Record<string, string | null> }>('/api/workspace/admin/brand/colors')
      .then(({ colors }) => {
        if (!cancelled) {
          setColor(colors['primary_color'] ?? '1E3A5F');
        }
      })
      .catch(() => {
        if (!cancelled) setColor('1E3A5F');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return color;
}
